import React, { Fragment, useRef, useState, useCallback, useEffect } from "react";
import { useSelector } from "react-redux";
import { Link, NavLink, useLocation, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import useRequireAuth from "../utils/useRequireAuth";
import { addParticularCompany } from "../utils/userSlice";
import { BASE_URL, NODE_URL } from "../utils/constants";
import { useNavigate } from "react-router-dom";
import { useFetchCompanyListQuery } from "../utils/company/companySelector";
import { useSidebar } from "./SidebarContext";
import useSorting from "../hooks/Table/useSortableColumn";
import { ReactComponent as ExpandSideBarImg } from "../assets/images/expandSideBarImg.svg";
import { ReactComponent as DownAngleBracket } from "../assets/images/downAngleBracket.svg";
import { ReactComponent as AccountMannagement } from "../assets/images/Account Mannagement.svg";
import { ReactComponent as AllTask } from "../assets/images/All Task.svg";
import { ReactComponent as Project } from "../assets/images/ToDoHubImg.svg";
import { ReactComponent as MySpace } from "../assets/images/My_space.svg";
import { ReactComponent as Vendor } from "../assets/images/Vendorr.svg";
import { ReactComponent as Others } from "../assets/images/Others.svg";
import { ReactComponent as BankTransfer } from "../assets/images/icons/bankTransferIcon.svg";
import { ReactComponent as ProjectFunnelIcon } from "../assets/images/projectFunnel.svg";
import Loader from "./UniversalComponents/Loader";
import FloatingList from "./UniversalComponents/FloatingElement";
import { ReactComponent as SettingNewIcon } from "../assets/images/icons/SettingNewIcon.svg";
import { ReactComponent as Template } from "../assets/images/icons/Template.svg";
import AvatarName from "./UniversalComponents/AvatarName";
import List from "./UniversalComponents/ListComponent";
import withPortalHOC from "./UniversalComponents/WithPortalHOC";
import { ReactComponent as EditIcon } from "../assets/images/newPencilEdit.svg";
import { ReactComponent as SettingWhiteIcon } from "../assets/images/icons/sideBarSettingIcon.svg";
import MySpacePinnedDrawer from "./mySpace/MySpacePinnedDrawer";
import { ReactComponent as GreenPin } from "../assets/images/green_pin.svg";
import { getCompanyId, getUserToken } from "../utils/utilityFunctions/localServices";
import { safeJsonStringify } from "../utils/utilityFunctions/stringUtility";
import { getTitleCase } from "../utils/utilityFunctions/stringUtility";

function formatValue(item) {
  if (item) {
    const words = item.split(" ");
    const firstWord = words[0];
    const lastWord = words[words?.length - 1];
    const firstChar = firstWord.charAt(0).toUpperCase();
    const lastChar = lastWord.charAt(0).toUpperCase();
    return `${firstChar}${lastChar}`;
  }
  return null;
}

const iconMap = {
  AccountManagementIcon: <AccountMannagement />,
  TodoHubIcon: <AllTask />,
  ProjectIcon: <Project className="pr-[1.5px]" />,
  VendorIcon: <Vendor className="ml-[1px]" />,
  MySpaceIcon: <MySpace />,
  ManageFunnelIcon: <ProjectFunnelIcon className="ml-[1.5px]" />,
  TemplateIcon: <Template />,
};

export function transformApiToMenu(menuItems) {
  return (menuItems || [])
    .filter((menu) => Boolean(menu))
    .map((item) => ({
      label: item.label,
      icon: item.is_custom_module ? item.icon : iconMap[item.icon],
      path: item.path,
      is_custom_module: item.is_custom_module ? true : false,
      isActive: false, // always false, not from item
      subItems: item.subItems ?? [],
    }));
}

function Leftmenu({ refreshKeyImage }) {
  const threedotmenu = useRef(null);

  const dispatch = useDispatch();
  const { token } = useRequireAuth();
  const navigate = useNavigate();
  const url = useLocation();
  const storedData = localStorage.getItem("company_data");
  const myUserData = localStorage.getItem("myUserData");
  const usetoken = myUserData ? JSON.parse(myUserData) : null;
  const tokens = token ? token : usetoken.token;
  const [activeMenuItem, setActiveMenuItem] = useState(url.pathname);
  const [searchText, setSearchText] = useState("");
  const [isRotated, setIsRotated] = useState(false);
  const [activeHoverItem, setActiveHoverItem] = useState(null);
  const companyId = storedData ? JSON.parse(storedData) : null;
  const { data: companyCommnData, error, isLoading, refetch } = useFetchCompanyListQuery(tokens);
  const user = useSelector((store) => store.user);

  const [asideWidth, setAsideWidth] = useState(null);
  const { sideBarColl, setSideBarColl } = useSidebar(false);
  const [isTaskPodOpen, setIsTaskPodOpen] = useState(false);

  const [customer, setCustomer] = useState([]);

  const [activeTaskpod, setActiveTaskpod] = useState("");
  const [isCOADropdownOpen, setIsDropdownOpen] = useState(false);
  const [isVendorDownOpen, setIsVendorDropdownOpen] = useState(false);

  const [isOthersoptions, setIsOthersoptions] = useState(false);
  const [showManageAcc, setShowManageAcc] = useState(false);
  const sidebarContext = useSidebar();
  const expandSideBar = sidebarContext?.expandSideBar;
  const [isMySpacePinnedDrawerOpen, setIsMySpacePinnedDrawerOpen] = useState(false);

  const useClickOutside = (callback) => {
    const ref = useRef(null);

    useEffect(() => {
      const handleClickOutside = (event) => {
        if (ref.current && !ref.current.contains(event.target)) {
          callback();
        }
      };

      document.addEventListener("mousedown", handleClickOutside);

      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [callback]);

    return ref;
  };

  useEffect(() => {
    if (sideBarColl) {
      setIsTaskPodOpen(false);
      setActiveTaskpod("");
    }
  }, [sideBarColl]);

  useEffect(() => {
    if (refreshKeyImage !== null) {
      refetch();
    }
  }, [refreshKeyImage, refetch]);

  const menuDropDown = (e) => {
    e.preventDefault();
    setShowManageAcc(!showManageAcc);
  };

  const threedotpanelcloseoutsideclick = useClickOutside(() => {
    setTimeout(() => {
      setShowManageAcc(false);
    }, 100);
  });

  const setSideMenuRef = useCallback((node) => {
    if (node) {
      const resizeObserver = new ResizeObserver(([entry]) => {
        setAsideWidth(entry.contentRect.width + 3);
      });
      resizeObserver.observe(node);
      return () => resizeObserver.disconnect();
    }
  }, []);

  const Expandside = () => {
    setSideBarColl(!sideBarColl);
    setIsRotated(!isRotated);
    setIsVendorDropdownOpen(false);
    setIsDropdownOpen(false);
    setIsOthersoptions(false);
    setMenuItems((prevMenuItems) => prevMenuItems.map((item) => ({ ...item, isActive: false })));
  };
  const handleMenuItemClick = (menuItem) => {
    setActiveMenuItem(menuItem);
  };

  const data = useParams();

  const [menuItems, setMenuItems] = useState([]);

  useEffect(() => {
    async function fetchMenu() {
      try {
        const res = await fetch(`${NODE_URL}fetch/main-header`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${getUserToken()}`, // 👈 attach your token here
          },
        });

        if (!res.ok) {
          throw new Error(`HTTP error! status: ${res.status}`);
        }

        const response = await res.json();
        const transformed = transformApiToMenu(response.data);
        localStorage.setItem("mainMenu", safeJsonStringify(transformed));

        localStorage.setItem("fullMenuList", safeJsonStringify(transformed));

        setMenuItems(transformed);
        if (transformed) {
          localStorage.setItem(
            "taskList",
            safeJsonStringify(transformed?.filter((item) => item.label === "My Activities")[0]?.subItems)
          );
          localStorage.setItem(
            "assignmentList",
            safeJsonStringify(transformed?.filter((item) => item.label === "My Assignment")[0]?.subItems)
          );
        }
      } catch (err) {
        console.error("Failed to load menu:", err);
      }
    }

    fetchMenu();
  }, []);

  const handleItemClick = (companyId, company_name, company_logo) => {
    dispatch(
      addParticularCompany({
        company_id: companyId,
        company_name,
        company_logo,
      })
    );
    navigate(`/edit_company/${companyId}`);
  };

  const handleMenuToggle = (clickedItem) => {
    setMenuItems((prevItems) =>
      prevItems.map((item) => ({
        ...item,
        isActive: item.label === clickedItem.label ? !clickedItem.isActive : false,
      }))
    );
  };

  const getPathSegments = (path) => (path ? path.split("?")[0].split("/") : []);

  const getMatchingPath = (path, activePath, is_custom_module) => {
    const pathSegments = getPathSegments(path);
    const activeSegments = getPathSegments(activePath);

    if (is_custom_module) {
      if (pathSegments[2] === activeSegments[2]) return true;
      return false;
    } else {
      return pathSegments[1] === activeSegments[1];
    }
  };

  return (
    <div className="bg-white h-full sticky top-0 z-[9999] thinscrollbar ">
      <Loader isLoading={isLoading} />

      {showManageAcc && (
        <div
          ref={threedotmenu}
          className={"rounded shadow-6 bg-secondary fixed mt-1"}
          style={{ left: `${asideWidth}px` }}
        >
          <div ref={threedotpanelcloseoutsideclick}>
            <div className={`bg-white border-b-2 px-3 py-4 flex items-center gap-3 `}>
              <SettingNewIcon className="fill-primary" />
              <Link to="/dashboardMain" className="text-primary text-lg font-medium hover:font-semibold">
                Manage Account
              </Link>
            </div>
            <ul className=" relative overflow-y-auto  w-[217px] h-[317px] thinscrollbar rounded-md bg-white m-2">
              {!companyCommnData?.data
                ? null
                : companyCommnData?.data?.map((list) => (
                    <li
                      className={` manageaccountli cursor-pointer hover:bg-primary-hover mr-2 rounded-md group ${list.company_name === companyId.company_name ? "bg-primary-active" : ""}`}
                      key={list.id}
                      onClick={() => {
                        handleItemClick(list.id, list.company_name, list?.company_logo);
                        window.location.reload(true);
                      }}
                    >
                      {/* {console.log("list_saumya", list.company_name)} */}
                      <div className="flex items-center ">
                        {/* {list?.company_logo ? (
                          <div className="h-10 w-10 sm:h-12 sm:w-12 p-3 bg-gray-200 flex items-center justify-center rounded-full">
                            <img
                              className="h-6 sm:h-7 mx-auto rounded"
                              src={`${BASE_URL}/${list?.company_logo}`}
                              alt="Logo"
                              style={{ fontSize: "1.5em" }}
                            />
                          </div>
                        ) : (
                          <div>
                            <AvatarName
                              name={formatValue(list.company_name)}
                              size="large"
                              bgColor={"#e8ecf299"}
                              textColor={"#7C7C83"}
                              borderColor={"#ABABAC"}
                            />
                          </div>
                        )} */}
                        <button className="text-[#666] text-sm font-normal mx-3 group flex items-center justify-between w-full h-10">
                          <span>{list.company_name}</span>

                          <span className=" items-center justify-center h-7 w-7 rounded-full hover:bg-white transition hidden group-hover:flex text-[#666]">
                            <EditIcon className="w-4 h-4 text-[#666]" />
                          </span>
                        </button>
                      </div>
                    </li>
                  ))}
            </ul>
          </div>
        </div>
      )}
      <div className="flex flex-col justify-between h-full bg-primary rounded rounded-t-lg">
        <div>
          <aside
            ref={setSideMenuRef}
            id="sidebar-multi-level-sidebar"
            className={`${
              sideBarColl ? "w-16 sidebaraside" : "min-w-[250px] mobtaskview"
            } top-0 left-0 z-[5000] transition-transform -translate-x-full sm:translate-x-0 bg-primary `}
            aria-label="Sidebar"
          >
            <div className="h-full overflow-y-auto sidebarscroll [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
              <div className="flex bg-primary px-2  justify-between items-center h-16 mb-2 border-b border-[#ffffffb3] ">
                <div className=" ">
                  <a
                    href="#"
                    className={` items-center ${sideBarColl ? "justify-center" : "justify-between"} ${expandSideBar ? "cursor-pointer" : "cursor-default"}  my-5`}
                  >
                    {!sideBarColl && (
                      <div className="flex items-center " onClick={(e) => menuDropDown(e)}>
                        {companyId?.company_logo ? (
                          <>
                            <img
                              className="h-10 w-10 min-w-10 me-3 sm:h-12 sm:w-12 sm:min-w-12 rounded-full"
                              src={`${BASE_URL}/${companyId?.company_logo}`}
                              alt="Logo"
                            />
                            <div className={`${sideBarColl ? "hidden" : "block"} text-white`}>
                              {companyId.company_name}
                            </div>
                          </>
                        ) : (
                          <>
                            <div
                              className={` ${sideBarColl ? "" : "me-3"} items-center justify-center `}
                              onClick={sideBarColl ? menuDropDown : null}
                            >
                              <AvatarName
                                name={formatValue(companyId.company_name)}
                                size="large"
                                bgColor={"#e5e7eb"}
                                textColor={"#7C7C83"}
                                borderColor={"#ABABAC"}
                              />
                              {/* <span className="text-xs text-gray-500">
                            <strong style={{ fontSize: "1.9em" }}>{formatValue(companyId.company_name)}</strong>
                          </span> */}
                            </div>
                            <span className={`${sideBarColl ? "hidden" : "block"} text-white `}>
                              {companyId.company_name}
                            </span>
                          </>
                        )}
                      </div>
                    )}
                    {sideBarColl && (
                      <div className="flex items-center">
                        {companyId?.company_logo ? (
                          <>
                            <div
                              className="h-10 w-10 me-3 sm:h-12 sm:w-14 rounded-full"
                              //  src={`${BASE_URL}/${companyId.company_logo}`}
                              // alt="Logo"
                            />
                            <div className={`${sideBarColl ? "hidden" : "block"} text-white`}>
                              {companyId.company_name}
                            </div>
                          </>
                        ) : (
                          <>
                            <div
                              className={`h-10 w-10 ${
                                sideBarColl ? "" : "me-3"
                              }  sm:h-12 sm:w-12  flex items-center justify-center rounded-full`}
                              onClick={sideBarColl ? menuDropDown : null}
                            ></div>
                            <span className={`${sideBarColl ? "hidden" : "block"} text-white `}>
                              {companyId?.company_name}
                            </span>
                          </>
                        )}
                      </div>
                    )}
                  </a>
                </div>
                {!sideBarColl && (
                  <div className="ms-2 py-2 mr-1">
                    <button onClick={Expandside}>
                      <ExpandSideBarImg
                        className={` transform ${
                          isRotated ? "rotate-180" : "-rotate-0"
                        } transition-transform duration-300`}
                      />
                    </button>
                  </div>
                )}
              </div>
              {sideBarColl && expandSideBar && (
                <div className="absolute left-[22px] top-[18px] ">
                  <button onClick={Expandside}>
                    <ExpandSideBarImg
                      className={` transform ${
                        isRotated ? "rotate-180" : "-rotate-0"
                      } transition-transform duration-300`}
                    />
                  </button>
                </div>
              )}
              {!expandSideBar && (
                <div className="absolute left-[10px] top-[10px] " onClick={(e) => menuDropDown(e)}>
                  <AvatarName
                    name={formatValue(companyId.company_name)}
                    size="large"
                    bgColor={"#e5e7eb"}
                    textColor={"#7C7C83"}
                    borderColor={"#ABABAC"}
                  />
                </div>
              )}

              {/* new bar */}
              <ul
                className={`${!sideBarColl ? "" : "px-2"} font-extralight items-center w-full flex space-y-1 flex-col`}
              >
                {menuItems?.map((item, index) => (
                  <li
                    key={index}
                    className={`parentmenu w-full flex  flex-col items-center justify-center relative rounded-lg `}
                    onMouseEnter={() =>
                      sideBarColl ? setActiveHoverItem(item?.label.toLowerCase().replace(/\s+/g, "_")) : null
                    }
                    onMouseLeave={() => (sideBarColl ? setActiveHoverItem(null) : null)}
                    onClick={(e) => {
                      e.stopPropagation();
                      handleMenuItemClick(item.path);
                    }}
                  >
                    {/* {console.log(
                      "pathSegments value",
                      getMatchingPath(item.path, activeMenuItem, item.is_custom_module)
                    )} */}
                    <Link
                      to={item.path}
                      className={`flex items-center justify-center w-[94%]  text-White transition duration-75 gap-4 group   ${
                        activeHoverItem === item?.label.toLowerCase().replace(/\s+/g, "_")
                      } text-14 ${!sideBarColl ? "pl-2 rounded-md" : "pl-[0.65rem] rounded-xl"} ${
                        getMatchingPath(item.path, activeMenuItem, item.is_custom_module)
                          ? "active bg-secondary"
                          : "hover:bg-secondary-hover"
                      } h-11`}
                    >
                      <div className="w-full flex items-center justify-between">
                        <div className="flex w-full ">
                          <div
                            className={`${
                              getMatchingPath(item.path, activeMenuItem, item.is_custom_module)
                                ? "text-primary"
                                : "text-white"
                            }`}
                          >
                            {item.is_custom_module ? <i className={`${item.icon} text-xl`} /> : item.icon}
                          </div>

                          {!sideBarColl && (
                            <span
                              className={`ms-2.5 font-500 ${
                                getMatchingPath(item.path, activeMenuItem, item.is_custom_module)
                                  ? "text-primary"
                                  : "text-white"
                              }`}
                            >
                              {getTitleCase(item.label)}
                            </span>
                          )}
                        </div>
                        {/* Show dropdown arrow if there are sub-items and sidebar is not collapsed */}
                        {!sideBarColl && item?.subItems.length > 0 && (
                          <span
                            className="flex items-center justify-center h-7 w-16 "
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              handleMenuToggle(item);
                            }}
                          >
                            <DownAngleBracket
                              className={`w-3 h-3 ${
                                getMatchingPath(item.path, activeMenuItem, item.is_custom_module)
                                  ? "text-primary"
                                  : "text-white"
                              } ${item.isActive ? "rotate-180" : ""}`}
                            />
                            {console.log("item_action", item)}
                          </span>
                        )}
                        {!sideBarColl && item?.action && item.action()}
                      </div>
                    </Link>

                    {/* {!sideBarColl && item.isActive && (
                      <div className="w-[94%] mt-1">
                        <ul
                          className=" w-[89%] flex flex-col  overflow-hidden border-l border-[white] ml-5  rounded-r-lg"
                          //onMouseLeave={() => handleMenuToggle(item)}
                        >
                          {item?.subItems?.map((subItem, subIndex) => (
                            <li
                              key={subIndex}
                              className="items-center justify-center flex text-center w-full rounded-md ml-4"
                              onClick={(e) => {
                                e.stopPropagation();
                                handleMenuItemClick(subItem.path);
                              }}
                            >
                              <Link
                                to={subItem.path}
                                className={`flex pl-6 w-full  py-2 text-white font-normal transition duration-75 ${activeMenuItem === subItem.path ? " text-white" : "text-white"}  gap-4 group hover:bg-[#759fff99] rounded-md`}
                                //  onMouseEnter={() => setshowCustomerHover(true)}
                                //  onMouseLeave={() => setshowCustomerHover(false)}
                              >
                                {!sideBarColl && <span>{subItem.label}</span>}
                              </Link>
                            </li>
                          ))}
                        </ul>
                      </div>
                    )} */}

                    {!sideBarColl && item.isActive && (
                      <div className="w-[94%] mt-1">
                        <ul className="w-[89%] flex flex-col max-h-[20vh] overflow-y-auto thinscrollbar border-l border-[white]/70 ml-5 pl-2">
                          {item?.subItems?.map((subItem, subIndex) => (
                            <li
                              key={subIndex}
                              className="flex items-center w-full"
                              onClick={(e) => {
                                e.stopPropagation();
                                handleMenuItemClick(subItem.path);
                              }}
                            >
                              <Link
                                to={subItem.path}
                                className={`flex w-full py-2 px-4 font-normal transition duration-75 gap-4
                                  ${
                                    activeMenuItem === subItem.path
                                      ? "bg-secondary text-primary rounded-md"
                                      : "text-white hover:bg-secondary-hover hover:rounded-md"
                                  }
                                `}
                              >
                                {!sideBarColl && <span>{getTitleCase(subItem.label)}</span>}
                              </Link>
                            </li>
                          ))}
                        </ul>
                      </div>
                    )}

                    {/* {hover sideDrawer} */}
                    {activeHoverItem === item?.label.toLowerCase().replace(/\s+/g, "_") && (
                      <FloatingList margin={0} xPadding={1}>
                        <div
                          className="bg-primary cursor-pointer flex flex-col px-2 items-start justify-between rounded-md ml-2"
                          onMouseEnter={() => setActiveHoverItem(item?.label.toLowerCase().replace(/\s+/g, "_"))}
                          //onMouseLeave={() => setActiveHoverItem(null)}
                        >
                          <Link
                            onClick={(e) => {
                              e.stopPropagation();
                              handleMenuItemClick(item?.label.toLowerCase().replace(/\s+/g, "_"));
                            }}
                            to={item.path}
                            className=" flex cursor-pointer "
                          >
                            <div className={`flex justify-between px-2 py-2 items-start min-w-52 h-full  `}>
                              <label className="text-base font-semibold cursor-pointer text-white max-w-[15ch] truncate whitespace-nowrap">
                                {item.label}
                              </label>

                              {item?.action && item.action()}
                            </div>
                          </Link>
                          <div className="max-h-[60vh] grow overflow-y-auto thinscrollbar flex flex-col items-start">
                            {item.subItems.map((subItem) => (
                              <div
                                className=" cursor-pointer flex pl-2 flex-col my-[2px] items-start justify-between 
                               hover:bg-secondary-hover hover:rounded-md  py-2 transition-all duration-200 "
                                onMouseEnter={() => setActiveHoverItem(item?.label.toLowerCase().replace(/\s+/g, "_"))}
                                //onMouseLeave={() => setActiveHoverItem(null)
                              >
                                <Link
                                  onClick={() => handleMenuItemClick(item?.label.toLowerCase().replace(/\s+/g, "_"))}
                                  to={subItem.path}
                                  className=" flex cursor-pointer  items-centre "
                                >
                                  <div className={`flex justify-between px-2  items-centre min-w-52 h-full`}>
                                    <label className="text-base font-normal cursor-pointer  text-white max-w-[15ch] truncate whitespace-nowrap">
                                      {getTitleCase(subItem.label)}
                                    </label>
                                  </div>
                                </Link>
                              </div>
                            ))}
                          </div>
                        </div>

                        {/* <div
                      className="mt-[1px]"
                      onMouseEnter={() => setActiveHoverItem(item.label.toLowerCase().replace(/\s+/g, "_"))}
                      onMouseLeave={() => handleMenuToggle(item)}
                    >
                      {item.isActive &&
                        item?.subItems?.map((subItem, subIndex) => (
                          <div key={subIndex} className="items-center w-full bg-1D4469 px-1 py-1">
                            <Link
                              to={subItem.path}
                              className={`flex items-center  px-3 py-1 text-White textnn transition duration-75 ${activeMenuItem === subItem?.path ? "bg-white text-black" : "text-white"}  gap-4 group hover:bg-[e]`}
                              onMouseEnter={() => setshowCustomerHover(true)}
                              onMouseLeave={() => setshowCustomerHover(false)}
                              onClick={(e) => {
                                e.stopPropagation();
                                handleMenuItemClick(subItem.path);
                              }}
                            >
                              <span>{subItem.label}</span>
                            </Link>
                          </div>
                        ))}
                    </div> */}
                      </FloatingList>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          </aside>
          {isMySpacePinnedDrawerOpen && (
            <MySpacePinnedDrawer onClose={() => setIsMySpacePinnedDrawerOpen(false)} open={isMySpacePinnedDrawerOpen} />
          )}
        </div>
        <div>
          {/* <Link
          to={"/audit-log"}
          className={`flex items-center justify-center gap-2  p-2 m-2 rounded-md  ${
            getMatchingPath("/audit-log", activeMenuItem, false) ? "active bg-[#fff] " : "hover:bg-[#759fff99]"
          }`}
        >
          <i
            className={`bi bi-file-text text-xl ${getMatchingPath("/audit-log", activeMenuItem, false) ? "text-primary " : "text-white"}`}
          ></i>{" "}
          {!sideBarColl && expandSideBar && <div className="text-white">{"Audit Log"}</div>}
        </Link> */}
          <Link
            to={"/setting"}
            onClick={(e) => {
              e.stopPropagation();
              handleMenuItemClick("/setting");
            }}
            // state={{companyid:getCompanyId() || ""}}
            className={` flex items-center justify-center gap-2  p-2 m-2 rounded-md ${
              getMatchingPath("/setting/", activeMenuItem, false) ? "active bg-secondary " : "hover:bg-secondary-hover"
            }`}
          >
            <div className={`${getMatchingPath("/setting/", activeMenuItem, false) ? "text-primary" : "text-white"}`}>
              <SettingWhiteIcon />
            </div>
            {!sideBarColl && expandSideBar && (
              <div className={`${getMatchingPath("/setting/", activeMenuItem, false) ? "text-primary" : "text-white"}`}>
                {"Company Settings"}
              </div>
            )}
          </Link>
        </div>
      </div>
    </div>
  );
}

export default Leftmenu;
